import classNames from "classnames";

import styles from "./FooterRenderZone.module.scss";

type FooterRenderZoneProps = {
  renderZone?: () => React.ReactNode;
  zoneTitle?: string;
  dataTestid?: string;
  containerClass?: string;
  hideZone?: boolean;
  showUpdatedFooterUI?: boolean;
};

export const FooterRenderZone = ({
  renderZone,
  zoneTitle,
  dataTestid = "footerRenderZone",
  containerClass,
  hideZone = false,
  showUpdatedFooterUI,
}: FooterRenderZoneProps) => {
  if (!renderZone || hideZone) {
    return;
  }

  const zoneContent = renderZone();

  if (!zoneContent) {
    return;
  }

  return (
    <div
      data-testid={dataTestid}
      className={classNames(
        styles.footerBottomZoneContent,
        {
          [styles.withTitle]: !!zoneTitle,
        },
        containerClass
      )}
    >
      {!!zoneTitle && <h4 className={styles.footerBottomZoneTitle}>{zoneTitle}</h4>}
      <div className={classNames({ [styles.footerRenderZone]: showUpdatedFooterUI })}>{zoneContent}</div>
    </div>
  );
};
